import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { closeSystemNotification, startSystemNotificationsPoll, stopSystemNotificationsPoll } from 'redux/admin/Actions'

const TOOLBAR_HEIGHT = 64

const styles = theme => ({
  container: {
    position: 'fixed',
    top: TOOLBAR_HEIGHT + theme.spacing.unit * 2,
    right: theme.spacing.unit * 2,
    zIndex: theme.zIndex.drawer,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    maxWidth: 360,
    pointerEvents: 'none',
  },
  card: {
    padding: theme.spacing.unit * 2,
    pointerEvents: 'all',
  },
  cardInfo: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
  cardWarning: {
    borderLeft: `4px solid ${theme.palette.error.main}`,
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing.unit,
  },
  details: {
    marginBottom: theme.spacing.unit * 1.5,
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
})

class SystemNotifications extends Component {
  severityCardClass = {
    info: 'cardInfo',
    warning: 'cardWarning',
  }
    
  componentDidMount() {
    this.props.startSystemNotificationsPoll({ msPolling: 60000 })
  }

  componentWillUnmount() {
    this.props.stopSystemNotificationsPoll()
  }

  render() {
    const { classes, systemNotifications, closeSystemNotification } = this.props

    if (!systemNotifications || systemNotifications.length === 0) return null

    return (
      <div className={classes.container}>
        {systemNotifications.map(notification => (
          <Paper key={notification.id} className={`${classes.card} ${classes[this.severityCardClass[notification.severity] || 'cardInfo']}`} elevation={3}>
            <Typography variant="subtitle1" className={classes.title}>
              {notification.title}
            </Typography>
            <Typography variant="body2" className={classes.details} dangerouslySetInnerHTML={{ __html: notification.details }} />
            <div className={classes.actions}>
              <Button
                size="small"
                color="primary"
                onClick={() => closeSystemNotification(notification.id)}
              >
                Remind Later
              </Button>
            </div>
          </Paper>
        ))}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  systemNotifications: state.admin.systemNotifications,
})

const mapDispatchToProps = {
  closeSystemNotification,
  startSystemNotificationsPoll,
  stopSystemNotificationsPoll,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(SystemNotifications))
